import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Wrapper = styled.div`
  background: no-repeat;
  background-size: cover;
  ${({ theme }) => renderStyledElementStyles(theme, theme.module.dStyles)}
  ${({ theme }) => renderStyledElementStyles(theme, theme.module.vStyles)}
`;

export const ModernCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.card)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.card)}
`;

export const Image = styled.div`
  aspect-ratio: 16/9;
  overflow: hidden;

  @media screen and (min-width: 768px) {
    display: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
